import { IStatisticsListItemConfig } from "./interfaces";
import { statisticsWidthMap } from "../constants";
import { IRoundBet } from "../../core/round/interfaces";

export class StatisticsItemMapper {
    public static convert(item: IRoundBet): IStatisticsListItemConfig {
        let config: Partial<IStatisticsListItemConfig> = {};
        for (let key in item) {
            config[key] = { style: { width: statisticsWidthMap[key] }, data: item[key] }
        }
        return config;
    }
}
